import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ITableFilterItem } from '../../../store/models/table.model';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-table-tags-filter',
  templateUrl: './table-tags-filter.component.html',
  styleUrls: ['./table-tags-filter.component.scss'],
})
export class TableTagsFilterComponent implements OnInit {
  @ViewChild('eRef') eRef: ElementRef;
  @Input() tags: ITableFilterItem[];
  @Input() buttonLabel = 'Search';
  @Output() search: EventEmitter<ITableFilterItem[]> = new EventEmitter<
    ITableFilterItem[]
  >();
  selectedTags: ITableFilterItem[] = [];
  showTagsList: boolean;
  icon = faChevronDown;

  constructor() {
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target) && ['svg', 'path'].indexOf(event.target.tagName) === -1) {
      this.showTagsList = false;
    }
  }

  ngOnInit(): void {
    if (!this.tags || !this.tags.length) {
      this.tags = [];
    }
  }

  renderTags(): string {
    // get first 3 tags
    if (!this.selectedTags.length) {
      return '';
    }

    if (this.selectedTags.length <= 5) {
      return this.selectedTags.map(tag => tag.label).join(', ');
    }
    return (
      this.selectedTags
        .slice(0, 5)
        .map(tag => tag.label)
        .join(', ') + '...'
    );
  }

  onClearInput() {
    this.selectedTags = [];
    this.search.emit(this.selectedTags);
  }

  onSearch() {
    this.search.emit(this.selectedTags.map(tag => tag.value));
    this.showTagsList = false;
  }

  toggleAvailableTags() {
    this.showTagsList = !this.showTagsList;
    this.icon = this.showTagsList ? faChevronUp : faChevronDown;
  }

  toggleTagSelection(tag: ITableFilterItem) {
    if (this.selectedTags.includes(tag)) {
      this.selectedTags = this.selectedTags.filter(t => t.id !== tag.id);
    } else {
      this.selectedTags.push(tag);
    }
  }

  isTagSelected(tag: ITableFilterItem) {
    return this.selectedTags.includes(tag);
  }
}
